import {
  Component,
  OnInit,
  Input,
  Output,
  ViewEncapsulation,
  EventEmitter,
  ViewContainerRef,
  ViewChild,
  ComponentFactoryResolver,
  ComponentRef,
  OnDestroy
} from '@angular/core';
import { DocsConfig } from './shared/docs-config.service';
import { DocsDataService } from './shared/docs-data.service';
import { Ng2FileInputComponent } from 'ng2-file-input';
import { ToastrService } from 'ngx-toastr';
import {
  Tarea,
  Documento,
  HistorialDocumento,
  RevisionDocumento,
  FuncionDocumento,
  Const,
  CondicionDocumento,
  Datos,
  SubForma,
  Control,
  Forma,
  Static,
  TablaDatos,
  DatesCondiction,
  DocumentoGenerado,
} from '@app/shared';
import { LocalDataSource } from 'ng2-smart-table';
import { find, findIndex } from 'lodash';
import { Subject } from 'rxjs';

@Component({
  selector: 'iw-docs',
  templateUrl: './docs.component.html',
  styleUrls: ['./docs.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [DocsDataService]
})
export class DocsComponent implements OnInit, OnDestroy {
  // Label de las extensiones permitidas
  @Input() extensionsLabel = 'jpg, png, pdf, xlsx, xls, docx, doc, tiff, tif';
  // Define la carga de multiples archivos
  @Input() multiple = false;
  // Oculta o muestra el boton de regresar
  @Input() single = true;
  // Oculta o muestra el titulo del componente
  @Input() title: Boolean = true;
  // Determina si el usuario en sesion es responsable de la tarea
  @Input() userResponsible = false;
  // Tarea actual
  @Input() task: Tarea;
  // Forma de la tarea
  @Input() form: Forma;
  // Define las extensiones de los archivos permitidos
  @Input() extensions: Array<string> = [
    'image/tiff-fx',
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'image/jpg',
    'image/png',
    'image/jpeg',
    'image/tif',
    'image/tiff'
  ];
  // Condiciones de acciones de los documentos en la tarea
  @Input() condictionsGenerate: Array<CondicionDocumento> = [];
  // Contiene los datos de todas las tablas inplicadas contando las tareas asociadas
  @Input() dataTableAll: TablaDatos[] = [];
  // Label de estenxiones para el accept del campo
  extensionsAccept = '';
  // define la vista a mostrar (subir documentos | ver revisiones)
  uploadDocument = true;
  // estdo de la tarea
  statusTask = true;
  // define cuando el documento seleccionado tiene la funcion de generar
  generate = false;
  // define cuando el documento seleccionado tiene la funcion de generar como requerida
  generateRequiered = false;
  // define cuando el documento seleccionado es de solo generacion
  generateOnly = false;
  // Define cuando esta subiendo un documento
  isLoading = false;
  // Configuracion de la tabla
  settings = {};
  // objeto de documentos
  documentsUpload: any[] = [];
  // Documentos descargados
  documentsDownload: any[] = [];
  // formulario
  formData = new FormData();
  // Informacion de la fila seleccionada de la tabla de docuemntos
  rowSelect: Documento = null;
  // Contiene las validaciones por documento
  condictionsDoc = {};
  // contiene los documentos de la tarea
  source: Array<Documento> = [];
  // datos para llenar la tabla
  sourceData: LocalDataSource;
  // revisiones del documento
  reviewDocuments: Array<RevisionDocumento>;
  documentsGenerated: DocumentoGenerado[] = [];
  // Evento que emite al presionar el boton de regresar
  @Output() close: EventEmitter<boolean> = new EventEmitter();
  // se emite cuando se hace la carga de los documentos
  @Output() docsUpload: EventEmitter<any> = new EventEmitter();
  // Se emite cuando se hace la descarga de un documento
  @Output() docsDownload: EventEmitter<any[]> = new EventEmitter();
  // Se emite cuando se hace la generacion de un documento
  @Output() docsGenerate: EventEmitter<DocumentoGenerado[]> = new EventEmitter();
  // Anclaje al contenedor de el componete de subir documentos
  @ViewChild('componentDocs', { read: ViewContainerRef }) componentDocs: ViewContainerRef;
  // Referencia al componente de subir documentos
  private componentRef: ComponentRef<Ng2FileInputComponent>;
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();

  constructor(
    private cfr: ComponentFactoryResolver,
    private dds: DocsDataService,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    for (let i = 0; i < this.extensions.length; i++) {
      this.extensionsAccept += this.extensions[i];
      if (i !== (this.extensions.length - 1)) {
        this.extensionsAccept += ', ';
      }
    }

    if (
      this.form &&
      this.form.estilo &&
      this.form.estilo['condiciones_documentos'] &&
      this.form.estilo['condiciones_documentos'].length
    ) {
      this.form.estilo['condiciones_documentos'].forEach((condictionDoc: CondicionDocumento) => {
        if (condictionDoc.formaDocumento) {
          if (!this.condictionsDoc.hasOwnProperty(condictionDoc.formaDocumento)) {
            this.condictionsDoc[condictionDoc.formaDocumento] = {};
          }
          if (!this.condictionsDoc[condictionDoc.formaDocumento].hasOwnProperty(condictionDoc['documento_nombre'])) {
            this.condictionsDoc[condictionDoc.formaDocumento][condictionDoc['documento_nombre']] = {
              condictionsDocs: [],
              condictionsGenerate: [],
            };
          }
          switch (condictionDoc.accionDocumento) {
            case 'subir':
              // tslint:disable-next-line:max-line-length
              this.condictionsDoc[condictionDoc.formaDocumento][condictionDoc['documento_nombre']].condictionsDocs.push(condictionDoc);
              break;
            case 'generar':
              // tslint:disable-next-line:max-line-length
              this.condictionsDoc[condictionDoc.formaDocumento][condictionDoc['documento_nombre']].condictionsGenerate.push(condictionDoc);
              break;
          }
        }
      });
    }

    if (this.task.tarea_estado.nombre === 'finalizado' || !this.userResponsible) {
      this.statusTask = false;
    }
    this.formData.append('id_tarea', String(this.task.id));
    const docsC = new DocsConfig();
    this.settings = docsC.settings;
    docsC.accion.subscribe(async (data: any) => {
      this.accionTable(data);
    });
    this.loadingDocs();
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  /**
   * Controla el evento al seleccionar una fila creando su respetivo componente para subir documento
   *
   * @param {*} data
   * @returns {*}
   * @memberof DocsComponent
   */
  clikRowSelect(data: any): any {
    if (this.statusTask) {
      const docGenerate = find(data.data.funciones, { funcion: Const.DOCUMENTS_FUNCTIONS.generate });
      if (docGenerate) {
        this.generate = true;
        if (docGenerate['obligatorio']) {
          this.generateRequiered = true;
        } else {
          this.generateRequiered = false;
        }
      } else {
        this.generateRequiered = false;
        this.generate = false;
      }
      if (this.componentDocs) {
        this.componentDocs.clear();
        const docUpload = find(data.data.funciones, { funcion: Const.DOCUMENTS_FUNCTIONS.upload });
        if (docUpload) {
          const validGenerated = this.validateGeneratedDocument(data.data);
          this.generateOnly = false;
          if (validGenerated) {
            const factory = this.cfr.resolveComponentFactory(Ng2FileInputComponent);
            this.componentRef = this.componentDocs.createComponent(factory);
            this.componentRef.instance.dropText = 'Subir archivo';
            this.componentRef.instance.browseText = 'Buscar';
            this.componentRef.instance.removeText = 'Eliminar';
            this.componentRef.instance.invalidFileText = 'Has elegido un archivo no válido o no permitido';
            this.componentRef.instance.extensions = this.extensions;
            this.componentRef.instance.accept = this.extensionsAccept;
            this.componentRef.instance.multiple = this.multiple;
            this.componentRef.instance.outputAction.subscribe((action: any) => {
              this.onAction(action);
            });
            this.rowSelect = data.data;
          } else {
            this.toastr.warning('Para subir este documento debe generarlo primero', 'Acción no permitida', {
              positionClass: 'toast-top-center'
            });
          }
        } else {
          this.generateOnly = true;
        }
      }
    }
  }

  /**
   * Controla los eventos en el componente de subir documentos
   *
   * @param {*} data
   * @returns {*}
   * @memberof DocsComponent
   */
  onAction(data: any): any {
    if (data.action === 1) {
      this.onAdded(data);
    } else if (data.action === 0) {
      this.onRemoved(data);
    }
  }

  /**
   * Controla el evento de remover un archivo del componente de documentos
   *
   * @param {*} data
   * @returns {*}
   * @memberof DocsComponent
   */
  onRemoved(data: any): any {
    this.formData.delete(data.file.name);
    for (let i = 0; i < this.documentsUpload.length; i++) {
      if (this.documentsUpload[i]['file'] === data.file.name) {
        this.documentsUpload.splice(i, 1);
      }
    }
  }

  /**
   * Controla el evento de agregar un archivo del componente de documentos
   *
   * @param {*} data
   * @returns {*}
   * @memberof DocsComponent
   */
  onAdded(data: any): any {
    let replace = false;
    for (let i = 0; i < this.documentsUpload.length; i++) {
      if (this.documentsUpload[i]['clasificacion_documento_id'] === this.rowSelect.clasificacion_id) {
        replace = true;
        this.formData.delete(this.documentsUpload[i]['file']);
        this.documentsUpload[i]['file'] = data.file.name;
        break;
      }
    }
    this.formData.append(data.file.name, data.file);
    if (!replace) {
      const dataD = {
        'clasificacion_documento_id': this.rowSelect.clasificacion_id,
        'file': data.file.name,
        'id_tarea': this.rowSelect.idtarea
      };

      if (this.rowSelect.documentos_detalle.length > 0) {
        dataD['id_documento'] = this.rowSelect.documentos_detalle[0].id_documento;
        if (this.rowSelect.documentos_detalle[0].radicado) {
          dataD['radicado'] = this.rowSelect.documentos_detalle[0].radicado;
        }
      }
      this.documentsUpload.push(dataD);
    }
  }

  /**
   * Emite el evento de regresar
   *
   * @returns {*}
   * @memberof DocsComponent
   */
  closeDocs(): any {
    this.close.emit(true);
  }

  /**
   * Accion de regresar del componente de revisiones
   *
   * @param {*} data
   * @returns {*}
   * @memberof DocsComponent
   */
  reviewBack(data: any): any {
    this.uploadDocument = data;
    this.rowSelect = null;
  }

  /**
   * Ejecuta el servicio para subir todos los documentos
   *
   * @returns {*}
   * @memberof DocsComponent
   */
  uploadDocs(): any {
    if (this.documentsUpload && this.documentsUpload.length) {
      this.isLoading = true;
      this.formData.append('documentos', JSON.stringify(this.documentsUpload));
      this.dds.uploadFile(this.formData).subscribe((res: any) => {
        this.isLoading = false;
        if (res.length === 0) {
          console.error('Fallo del sistema');
        } else {
          this.documentsUpload = [];
          delete this.rowSelect;
          this.formData = new FormData();
          this.formData.append('id_tarea', String(this.task.id));
          for (let i = 0; i < res.length; i++) {
            for (let s = 0; s < this.source.length; s++) {
              if (
                res[i]['clasificacion_documento_id'] === this.source[s].clasificacion_id &&
                res[i]['id_tarea'] === this.source[s].idtarea
              ) {
                let indexDetalle: number = this.source[s].documentos_detalle.length - 1;
                let versionDoc = 0;
                if (indexDetalle > 0) {
                  versionDoc = this.source[s].documentos_detalle[indexDetalle].historial.length + 1;
                }
                const historyDocument: HistorialDocumento = {
                  id: res[i]['id'],
                  nombre: res[i]['nombre'],
                  nombre_archivo: res[i]['nombre_archivo'],
                  extension: res[i]['extension'],
                  version: res[i]['version'],
                  revision: [],
                  tarea_origen: res[i]['tarea_origen']
                };
                if (indexDetalle < 0) {
                  this.source[s]
                    .documentos_detalle.push({
                      id_documento: res[i]['documento_id'],
                      historial: []
                    });
                  indexDetalle = this.source[s].documentos_detalle.length - 1;
                } else {
                  this.source[s].documentos_detalle[indexDetalle].id_documento = res[i]['documento_id'];
                }
                if (versionDoc === 0) {
                  versionDoc = 1;
                }

                this.source[s]
                  .documentos_detalle[indexDetalle]
                  .historial.push(historyDocument);
                break;
              }
            }
          }
          this.componentDocs.clear();
          const dataDocs: Documento[] = Static.copyObjet(this.source);
          if (dataDocs && dataDocs.length) {
            dataDocs.forEach(doc => {
              let docPrincipal: Documento;
              if (this.task.id === doc.idtarea) {
                docPrincipal = find(this.task.documentos, {clasificacion_id: doc.clasificacion_id});
              } else {
                const taskAssociation = find(this.task.tarea_asociacion, {id_tarea_destino: doc.idtarea});
                if (taskAssociation) {
                  docPrincipal = find(taskAssociation.documentos, {clasificacion_id: doc.clasificacion_id});
                }
              }
              if (docPrincipal) {
                doc.funciones = docPrincipal.funciones;
              }
            });
          }
          this.docsUpload.emit(dataDocs);
          this.loadingDocs();
        }
      },
      err => {
        this.isLoading = false;
      });
    }
  }

  /**
   * Carga los documentos de la tarea
   *
   * @returns {*}
   * @memberof DocsComponent
   */
  loadingDocs(): any {
    if (this.componentDocs) {
      this.componentDocs.clear();
    }
    if (this.rowSelect) {
      this.rowSelect = null;
    }
    if (this.task.documentos.length) {
      this.task.documentos.forEach(document => {
        document.funciones.forEach(funcion => {
          if (
            funcion.funcion === Const.DOCUMENTS_FUNCTIONS.upload ||
            funcion.funcion === Const.DOCUMENTS_FUNCTIONS.generate ||
            funcion.funcion === Const.DOCUMENTS_FUNCTIONS.dowload
          ) {
            const existDocument = find(this.source, {
              clasificacion_id: document.clasificacion_id,
              idtarea: this.task.id
            });
            if (!existDocument) {
              const doc: Documento = Static.copyObjet(document);
              doc.idtarea = this.task.id;
              this.source.push(doc);
            }
          }
        });
      });
    }
    if (this.task.tarea_asociacion.length) {
      this.task.tarea_asociacion.forEach(taskAsociation => {
        taskAsociation.documentos.forEach(document => {
          document.funciones.forEach(funcion => {
            if (
              funcion.funcion === Const.DOCUMENTS_FUNCTIONS.upload ||
              funcion.funcion === Const.DOCUMENTS_FUNCTIONS.generate ||
              funcion.funcion === Const.DOCUMENTS_FUNCTIONS.dowload
            ) {
              const existDocument = find(this.source, {
                clasificacion_id: document.clasificacion_id,
                idtarea: taskAsociation.id_tarea_destino
              });
              if (!existDocument) {
                const doc: Documento = Static.copyObjet(document);
                doc.idtarea = taskAsociation.id_tarea_destino;
                this.source.push(doc);
              }
            }
          });
        });
      });
    }
    if (this.source && this.source.length) {
      const copyDocuments: Documento[] = [];
      this.source.forEach(doc => {
        if (doc.idtarea === this.task.id) {
          if (
            this.form &&
            this.condictionsDoc[this.form.alias] &&
            this.condictionsDoc[this.form.alias][doc.clasificacion]
          ) {
            if (doc.funciones && doc.funciones.length) {
              const functions: FuncionDocumento[] = Static.copyObjet(doc.funciones);
              functions.forEach(funtion => {
                switch (funtion.funcion) {
                  case Const.DOCUMENTS_FUNCTIONS.upload:
                    this.validCondictionsDoc(
                      this.condictionsDoc[this.form.alias][doc.clasificacion]['condictionsDocs'],
                      doc,
                      funtion.funcion
                    );
                    break;
                  case Const.DOCUMENTS_FUNCTIONS.generate:
                    this.validCondictionsDoc(
                      this.condictionsDoc[this.form.alias][doc.clasificacion]['condictionsGenerate'],
                      doc,
                      funtion.funcion
                    );
                    break;
                }
              });
            }
          }
        } else {
          if (this.task.tarea_asociacion && this.task.tarea_asociacion.length) {
            const taskAssociation = find(this.task.tarea_asociacion, {id_tarea_destino: doc.idtarea});
            if (
              taskAssociation &&
              this.condictionsDoc[taskAssociation.alias] &&
              this.condictionsDoc[taskAssociation.alias][doc.clasificacion]
            ) {
              if (doc.funciones && doc.funciones.length) {
                const functions: FuncionDocumento[] = Static.copyObjet(doc.funciones);
                functions.forEach(funtion => {
                  switch (funtion.funcion) {
                    case Const.DOCUMENTS_FUNCTIONS.upload:
                      this.validCondictionsDoc(
                        this.condictionsDoc[taskAssociation.alias][doc.clasificacion]['condictionsDocs'],
                        doc,
                        funtion.funcion
                      );
                      break;
                    case Const.DOCUMENTS_FUNCTIONS.generate:
                      this.validCondictionsDoc(
                        this.condictionsDoc[taskAssociation.alias][doc.clasificacion]['condictionsGenerate'],
                        doc,
                        funtion.funcion
                      );
                      break;
                  }
                });
              }
            }
          }
        }
      });
      this.validCondictionsGenerateDocs();
      this.source.forEach(doc => {
        if (doc.funciones && doc.funciones.length) {
          let functionExist: FuncionDocumento;
          functionExist = find(doc.funciones, {funcion: Const.DOCUMENTS_FUNCTIONS.upload});
          if (functionExist) {
            copyDocuments.push(doc);
          } else {
            functionExist = find(doc.funciones, {funcion: Const.DOCUMENTS_FUNCTIONS.generate});
            if (functionExist) {
              copyDocuments.push(doc);
            } else {
              functionExist = find(doc.funciones, {funcion: Const.DOCUMENTS_FUNCTIONS.dowload});
            if (functionExist) {
              copyDocuments.push(doc);
            }
            }
          }
        }
      });
      this.source = copyDocuments;
    } 
    this.source[0]['select'] = false;
    this.sourceData = new LocalDataSource(this.source);
    this.sourceData.refresh();
  }

  /**
   * Desacarga el archivo del documento selecionado
   *
   * @private
   * @param {*} data
   * @returns {*}
   * @memberof DocsComponent
   */
  private download(data: number): any {
    const indexDownload = findIndex(this.documentsDownload, el => el === data);
    if (indexDownload === -1) {
      this.documentsDownload.push(data);
      this.docsDownload.emit(this.documentsDownload);
    }
    this.dds.dowloadFile(data).subscribe((res: any) => {
      const a = document.createElement('a');
      a.target = '_blank';
      a.href = res.file.path;
      a.download = res.file.name;
      a.click();
      a.remove();
    });
  }

  /**
   * Setea la data de el componente de revisiones del documento
   *
   * @private
   * @param {*} data
   * @returns {*}
   * @memberof DocsComponent
   */
  private reviewDocument(data: any): any {
    this.reviewDocuments = data;
    this.uploadDocument = false;
  }

  /**
   * Validacion de las condiciones de los documentos para la funcion de Generar
   *
   * @private
   * @memberof DocsComponent
   */
  private validCondictionsGenerateDocs() {
    let valid = true;
    if (this.condictionsGenerate && this.condictionsGenerate.length) {
      let valView = false;
      let valHide = false;
      let firstView = true;
      let firstHide = true;
      let operactorNext = 'O';
      this.condictionsGenerate.forEach(condiction => {
        let date = false;
        let comply = false;
        let value: Datos = null;
        let formulario: SubForma;
        let control: Control;
        let valor: any;
        const moment = require('moment');
        if (!Number(condiction.valor)) {
          if (condiction.valor &&  moment(new Date(String(condiction.valor))).isValid()) {
            date = true;
          } else if (condiction.fechaActual) {
            condiction.valor = new Date();
            date = true;
          } else {
            date = false;
          }
        } else {
          date = false;
        }
        if (this.form && this.form.alias === condiction.forma) {
          formulario = find(this.form.sub_formas, {alias: condiction.formulario});
          if (formulario) {
            control = find(formulario.campos, {alias: condiction.campo});
            if (control) {
              if (this.task.datos && this.task.datos.length) {
                value = find(this.task.datos, {nombre_campo: control.nombre_campo});
              }
            }
          }
        } else {
          if (this.task.tarea_asociacion && this.task.tarea_asociacion.length) {
            const tasAssociation = find(this.task.tarea_asociacion, {alias: condiction.forma});
            if (tasAssociation) {
              if (tasAssociation.datos && tasAssociation.datos.length) {
                value = find(tasAssociation.datos, {alias_formulario: condiction.formulario, alias: condiction.campo});
              }
            }
          }
        }
        if (value) {
          valor = value.valor;
        }
        switch (condiction.siEs) {
          case 'Vacio':
            if (
              !valor ||
              valor === ''
            ) {
              comply = true;
            } else {
              comply = false;
            }
            break;
          case 'Diferente':
            if (!date) {
              if (String(valor).toLowerCase() !== String(condiction.valor).toLowerCase()) {
                comply = true;
              } else {
                comply = false;
              }
            } else {
              let dtValorControl: Date = null;
              if (value && value.tipo && value.tipo === 'date-time-picker') {
                let valorCondiction: string = null;
                let valorControl: string = null;
                const dtValor: Date = new Date(condiction.valor);
                switch (value.clasificacion) {
                  case 'calendar':
                    valorCondiction = dtValor.toLocaleDateString();
                    dtValorControl = new Date(valor);
                    if (moment(dtValorControl).isValid()) {
                      valorControl = dtValorControl.toLocaleDateString();
                    }
                    break;
                  case 'timer':
                    dtValor.setSeconds(0, 0);
                    valorCondiction = dtValor.toLocaleTimeString();
                    dtValorControl = new Date(valor);
                    if (moment(dtValorControl).isValid()) {
                      dtValorControl.setSeconds(0, 0);
                      valorControl = dtValorControl.toLocaleTimeString();
                    }
                    break;
                  default:
                    dtValor.setSeconds(0, 0);
                    valorCondiction = dtValor.toLocaleDateString();
                    valorCondiction += ' ' + dtValor.toLocaleTimeString();
                    dtValorControl = new Date(valor);
                    if (moment(dtValorControl).isValid()) {
                      dtValorControl.setSeconds(0, 0);
                      valorControl = dtValorControl.toLocaleDateString();
                      valorControl += ' ' + dtValorControl.toLocaleTimeString();
                    }
                    break;
                }
                if (valorControl !== valorCondiction) {
                  comply = true;
                } else {
                  comply = false;
                }
              } else {
                dtValorControl = new Date(valor);
                // tslint:disable-next-line:max-line-length
                if (moment(dtValorControl).isValid() && dtValorControl.toLocaleDateString() !== new Date(condiction.valor).toLocaleDateString()) {
                  comply = true;
                } else {
                  comply = false;
                }
              }
            }
            break;
          case 'Mayor a':
            if (!date) {
              if (Number(valor) > Number(condiction.valor)) {
                comply = true;
              } else {
                comply = false;
              }
            } else {
              let dtValorControl: Date = null;
              let valorCondiction: Date = null;
              valorCondiction = new Date(condiction.valor);
              dtValorControl = new Date(valor);
              if (value && value.tipo && value.tipo === 'date-time-picker') {
                switch (value.clasificacion) {
                  case 'calendar':
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                        dtValorControl.setHours(0, 0, 0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setHours(0, 0, 0, 0);
                    }
                    break;
                  case 'timer':
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setDate(new Date().getDate());
                      dtValorControl.setMonth(new Date().getMonth());
                      dtValorControl.setFullYear(new Date().getFullYear());
                      dtValorControl.setSeconds(0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setDate(new Date().getDate());
                      valorCondiction.setMonth(new Date().getMonth());
                      valorCondiction.setFullYear(new Date().getFullYear());
                      valorCondiction.setSeconds(0, 0);
                    }
                    break;
                  default:
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setSeconds(0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setSeconds(0, 0);
                    }
                    break;
                }
              } else {
                if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                    dtValorControl.setHours(0, 0, 0, 0);
                }
                if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                  valorCondiction.setHours(0, 0, 0, 0);
                }
              }
              // Operacion
              if (
                (dtValorControl instanceof Date && moment(dtValorControl).isValid()) &&
                (valorCondiction instanceof Date && moment(valorCondiction).isValid()) &&
                dtValorControl > valorCondiction
              ) {
                comply = true;
              } else {
                comply = false;
              }
            }
            break;
          case 'Mayor o igual a':
            if (!date) {
              if (Number(valor) >= Number(condiction.valor)) {
                comply = true;
              } else {
                comply = false;
              }
            } else {
              let dtValorControl: Date = null;
              let valorCondiction: Date = null;
              valorCondiction = new Date(condiction.valor);
              dtValorControl = new Date(valor);
              if (value && value.tipo && value.tipo === 'date-time-picker') {
                switch (value.clasificacion) {
                  case 'calendar':
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                        dtValorControl.setHours(0, 0, 0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setHours(0, 0, 0, 0);
                    }
                    break;
                  case 'timer':
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setDate(new Date().getDate());
                      dtValorControl.setMonth(new Date().getMonth());
                      dtValorControl.setFullYear(new Date().getFullYear());
                      dtValorControl.setSeconds(0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setDate(new Date().getDate());
                      valorCondiction.setMonth(new Date().getMonth());
                      valorCondiction.setFullYear(new Date().getFullYear());
                      valorCondiction.setSeconds(0, 0);
                    }
                    break;
                  default:
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setSeconds(0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setSeconds(0, 0);
                    }
                    break;
                }
              } else {
                if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                    dtValorControl.setHours(0, 0, 0, 0);
                }
                if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                  valorCondiction.setHours(0, 0, 0, 0);
                }
              }
              // Operacion
              if (
                (dtValorControl instanceof Date && moment(dtValorControl).isValid()) &&
                (valorCondiction instanceof Date && moment(valorCondiction).isValid()) &&
                dtValorControl >= valorCondiction
              ) {
                comply = true;
              } else {
                comply = false;
              }
            }
            break;
          case 'Menor a':
            if (!date) {
              if (Number(valor) < Number(condiction.valor)) {
                comply = true;
              } else {
                comply = false;
              }
            } else {
              let dtValorControl: Date = null;
              let valorCondiction: Date = null;
              valorCondiction = new Date(condiction.valor);
              dtValorControl = new Date(valor);
              if (value && value.tipo && value.tipo === 'date-time-picker') {
                switch (value.clasificacion) {
                  case 'calendar':
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                        dtValorControl.setHours(0, 0, 0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setHours(0, 0, 0, 0);
                    }
                    break;
                  case 'timer':
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setDate(new Date().getDate());
                      dtValorControl.setMonth(new Date().getMonth());
                      dtValorControl.setFullYear(new Date().getFullYear());
                      dtValorControl.setSeconds(0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setDate(new Date().getDate());
                      valorCondiction.setMonth(new Date().getMonth());
                      valorCondiction.setFullYear(new Date().getFullYear());
                      valorCondiction.setSeconds(0, 0);
                    }
                    break;
                  default:
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setSeconds(0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setSeconds(0, 0);
                    }
                    break;
                }
              } else {
                if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                    dtValorControl.setHours(0, 0, 0, 0);
                }
                if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                  valorCondiction.setHours(0, 0, 0, 0);
                }
              }
              // Operacion
              if (
                (dtValorControl instanceof Date && moment(dtValorControl).isValid()) &&
                (valorCondiction instanceof Date && moment(valorCondiction).isValid()) &&
                dtValorControl < valorCondiction
              ) {
                comply = true;
              } else {
                comply = false;
              }
            }
            break;
          case 'Menor o igual a':
            if (!date) {
              if (Number(valor) <= Number(condiction.valor)) {
                comply = true;
              } else {
                comply = false;
              }
            } else {
              let dtValorControl: Date = null;
              let valorCondiction: Date = null;
              valorCondiction = new Date(condiction.valor);
              dtValorControl = new Date(valor);
              if (value && value.tipo === 'date-time-picker') {
                switch (value.clasificacion) {
                  case 'calendar':
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                        dtValorControl.setHours(0, 0, 0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setHours(0, 0, 0, 0);
                    }
                    break;
                  case 'timer':
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setDate(new Date().getDate());
                      dtValorControl.setMonth(new Date().getMonth());
                      dtValorControl.setFullYear(new Date().getFullYear());
                      dtValorControl.setSeconds(0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setDate(new Date().getDate());
                      valorCondiction.setMonth(new Date().getMonth());
                      valorCondiction.setFullYear(new Date().getFullYear());
                      valorCondiction.setSeconds(0, 0);
                    }
                    break;
                  default:
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setSeconds(0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setSeconds(0, 0);
                    }
                    break;
                }
              } else {
                if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                    dtValorControl.setHours(0, 0, 0, 0);
                }
                if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                  valorCondiction.setHours(0, 0, 0, 0);
                }
              }
              // Operacion
              if (
                (dtValorControl instanceof Date && moment(dtValorControl).isValid()) &&
                (valorCondiction instanceof Date && moment(valorCondiction).isValid()) &&
                dtValorControl <= valorCondiction
              ) {
                comply = true;
              } else {
                comply = false;
              }
            }
            break;
          default:
            if (!date) {
              if (String(valor).toLowerCase() === String(condiction.valor).toLowerCase()) {
                comply = true;
              } else {
                comply = false;
              }
            } else {
              let dtValorControl: Date = null;
              if (value && value.tipo && value.tipo === 'date-time-picker') {
                let valorCondiction: string = null;
                let valorControl: string = null;
                const dtValor: Date = new Date(condiction.valor);
                switch (value.clasificacion) {
                  case 'calendar':
                    valorCondiction = dtValor.toLocaleDateString();
                    dtValorControl = new Date(valor);
                    if (moment(dtValorControl).isValid()) {
                      valorControl = dtValorControl.toLocaleDateString();
                    }
                    break;
                  case 'timer':
                    dtValor.setSeconds(0, 0);
                    valorCondiction = dtValor.toLocaleTimeString();
                    dtValorControl = new Date(valor);
                    if (moment(dtValorControl).isValid()) {
                      dtValorControl.setSeconds(0, 0);
                      valorControl = dtValorControl.toLocaleTimeString();
                    }
                    break;
                  default:
                    dtValor.setSeconds(0, 0);
                    valorCondiction = dtValor.toLocaleDateString();
                    valorCondiction += ' ' + dtValor.toLocaleTimeString();
                    dtValorControl = new Date(valor);
                    if (moment(dtValorControl).isValid()) {
                      dtValorControl.setSeconds(0, 0);
                      valorControl = dtValorControl.toLocaleDateString();
                      valorControl += ' ' + dtValorControl.toLocaleTimeString();
                    }
                    break;
                }
                if (valorControl === valorCondiction) {
                  comply = true;
                } else {
                  comply = false;
                }
              } else {
                dtValorControl = new Date(valor);
                // tslint:disable-next-line:max-line-length
                if (moment(dtValorControl).isValid() && dtValorControl.toLocaleDateString() === new Date(condiction.valor).toLocaleDateString()) {
                  comply = true;
                } else {
                  comply = false;
                }
              }
            }
            break;
        }
        switch (condiction.accion) {
          case 'Mostrar':
            if (!firstView) {
              if (!operactorNext || operactorNext === 'O') {
                if (valView || comply) {
                  valView = true;
                } else {
                  valView = false;
                }
              } else {
                if (valView && comply) {
                  valView = true;
                } else {
                  valView = false;
                }
              }
            } else {
              firstView = false;
              firstHide = true;
              valView = comply;
            }
            valHide = !valView;
            operactorNext = condiction.operadorCondicion;
            break;
          case 'Ocultar':
            if (!firstHide) {
              if (!operactorNext || operactorNext === 'O') {
                if (valHide || comply) {
                  valHide = true;
                } else {
                  valHide = false;
                }
              } else {
                if (valHide && comply) {
                  valHide = true;
                } else {
                  valHide = false;
                }
              }
            } else {
              firstHide = false;
              firstView = true;
              valHide = comply;
            }
            valView = !valHide;
            operactorNext = condiction.operadorCondicion;
            break;
        }
      });
      if (valView || !valHide) {
        valid = true;
      } else {
        valid = false;
      }
    }
    if (!valid) {
      this.source.forEach(doc => {
        if (doc.funciones && doc.funciones.length) {
          const indexfunction = findIndex(doc.funciones, {funcion: Const.DOCUMENTS_FUNCTIONS.generate});
          if (indexfunction !== -1) {
            doc.funciones.splice(indexfunction, 1);
          }
        }
      });
    }
  }

  /**
   * Validacion de las condiciones de un documento para la funcion de Subir y generar
   *
   * @private
   * @param {Array<CondicionDocumento>} condictions - condiciones de la funcion del documento
   * @param {Documento} document - documento
   * @param {string} [funcion='Subir'] - funcion a validar
   * @memberof DocsComponent
   */
  private validCondictionsDoc(
    condictions: Array<CondicionDocumento>,
    document: Documento,
    funcion: string = 'Subir'
  ) {
    let valid = true;
    if (condictions && condictions.length) {
      let valView = false;
      let valHide = false;
      let firstView = true;
      let firstHide = true;
      let operactorNext = 'O';
      condictions.forEach(condiction => {
        let date = false;
        let comply = false;
        let value: Datos = null;
        let formulario: SubForma;
        let control: Control;
        let valor: any;
        const moment = require('moment');
        if (!Number(condiction.valor) || condiction.fechaActual) {
          if (condiction.valor &&  moment(new Date(String(condiction.valor))).isValid()) {
            date = true;
          } else if (condiction.fechaActual) {
            condiction.valor = new Date();
            date = true;
          } else {
            date = false;
          }
        } else {
          date = false;
        }
        if (this.form && this.form.alias === condiction.forma) {
          formulario = find(this.form.sub_formas, {alias: condiction.formulario});
          if (formulario) {
            control = find(formulario.campos, {alias: condiction.campo});
            if (!formulario.tabla) {
              if (control) {
                if (this.task.datos && this.task.datos.length) {
                  value = find(this.task.datos, {nombre_campo: control.nombre_campo});
                }
              }
            } else {
              valor = [];
              if (control) {
                const table = find(
                  this.task.tabla_datos as TablaDatos[],
                  (t: TablaDatos) => t.alias === condiction.formulario
                );
                if (table && table.valores && table.valores.length) {
                  table.valores.forEach((row: any) => {
                    if (row[table.labels[control.alias]]) {
                      valor.push(row[table.labels[control.alias]]);
                    }
                  });
                }
              }
            }
          }
        } else {
          if (this.task.tarea_asociacion && this.task.tarea_asociacion.length) {
            const tasAssociation = find(this.task.tarea_asociacion, {alias: condiction.forma});
            if (tasAssociation) {
              if (tasAssociation.datos && tasAssociation.datos.length) {
                value = find(tasAssociation.datos, {alias_formulario: condiction.formulario, alias: condiction.campo});
              }
            }
            if (!value) {
              if (this.dataTableAll.length) {
                const table = find(this.dataTableAll, {alias: condiction.formulario});
                if (table) {
                  valor = [];
                  table.valores.forEach((row: any) => {
                    if (row[table.labels[condiction.campo]]) {
                      valor.push(row[table.labels[condiction.campo]]);
                    }
                  });
                }
              }
            }
          }
        }
        if (value) {
          valor = value.valor;
        }
        switch (condiction.siEs) {
          case 'Vacio':
            if (
              !valor ||
              valor === ''
            ) {
              comply = true;
            } else {
              comply = false;
            }
            break;
          case 'Diferente':
            if (!date) {
              if (String(valor).toLowerCase() !== String(condiction.valor).toLowerCase()) {
                comply = true;
              } else {
                comply = false;
              }
            } else {
              let dtValorControl: Date = null;
              if (value && value.tipo && value.tipo === 'date-time-picker') {
                let valorCondiction: string = null;
                let valorControl: string = null;
                const dtValor: Date = new Date(condiction.valor);
                switch (value.clasificacion) {
                  case 'calendar':
                    valorCondiction = dtValor.toLocaleDateString();
                    dtValorControl = new Date(valor);
                    if (moment(dtValorControl).isValid()) {
                      valorControl = dtValorControl.toLocaleDateString();
                    }
                    break;
                  case 'timer':
                    dtValor.setSeconds(0, 0);
                    valorCondiction = dtValor.toLocaleTimeString();
                    dtValorControl = new Date(valor);
                    if (moment(dtValorControl).isValid()) {
                      dtValorControl.setSeconds(0, 0);
                      valorControl = dtValorControl.toLocaleTimeString();
                    }
                    break;
                  default:
                    dtValor.setSeconds(0, 0);
                    valorCondiction = dtValor.toLocaleDateString();
                    valorCondiction += ' ' + dtValor.toLocaleTimeString();
                    dtValorControl = new Date(valor);
                    if (moment(dtValorControl).isValid()) {
                      dtValorControl.setSeconds(0, 0);
                      valorControl = dtValorControl.toLocaleDateString();
                      valorControl += ' ' + dtValorControl.toLocaleTimeString();
                    }
                    break;
                }
                if (valorControl !== valorCondiction) {
                  comply = true;
                } else {
                  comply = false;
                }
              } else {
                dtValorControl = new Date(valor);
                // tslint:disable-next-line:max-line-length
                if (moment(dtValorControl).isValid() && dtValorControl.toLocaleDateString() !== new Date(condiction.valor).toLocaleDateString()) {
                  comply = true;
                } else {
                  comply = false;
                }
              }
            }
            break;
          case 'Mayor a':
            if (!date) {
              if (Number(valor) > Number(condiction.valor)) {
                comply = true;
              } else {
                comply = false;
              }
            } else {
              let dtValorControl: Date = null;
              let valorCondiction: Date = null;
              valorCondiction = new Date(condiction.valor);
              dtValorControl = new Date(valor);
              if (value && value.tipo && value.tipo === 'date-time-picker') {
                switch (value.clasificacion) {
                  case 'calendar':
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                        dtValorControl.setHours(0, 0, 0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setHours(0, 0, 0, 0);
                    }
                    break;
                  case 'timer':
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setDate(new Date().getDate());
                      dtValorControl.setMonth(new Date().getMonth());
                      dtValorControl.setFullYear(new Date().getFullYear());
                      dtValorControl.setSeconds(0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setDate(new Date().getDate());
                      valorCondiction.setMonth(new Date().getMonth());
                      valorCondiction.setFullYear(new Date().getFullYear());
                      valorCondiction.setSeconds(0, 0);
                    }
                    break;
                  default:
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setSeconds(0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setSeconds(0, 0);
                    }
                    break;
                }
              } else {
                if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                    dtValorControl.setHours(0, 0, 0, 0);
                }
                if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                  valorCondiction.setHours(0, 0, 0, 0);
                }
              }
              // Operacion
              if (
                (dtValorControl instanceof Date && moment(dtValorControl).isValid()) &&
                (valorCondiction instanceof Date && moment(valorCondiction).isValid()) &&
                dtValorControl > valorCondiction
              ) {
                comply = true;
              } else {
                comply = false;
              }
            }
            break;
          case 'Mayor o igual a':
            if (!date) {
              if (Number(valor) >= Number(condiction.valor)) {
                comply = true;
              } else {
                comply = false;
              }
            } else {
              let dtValorControl: Date = null;
              let valorCondiction: Date = null;
              valorCondiction = new Date(condiction.valor);
              dtValorControl = new Date(valor);
              if (value && value.tipo && value.tipo === 'date-time-picker') {
                switch (value.clasificacion) {
                  case 'calendar':
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                        dtValorControl.setHours(0, 0, 0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setHours(0, 0, 0, 0);
                    }
                    break;
                  case 'timer':
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setDate(new Date().getDate());
                      dtValorControl.setMonth(new Date().getMonth());
                      dtValorControl.setFullYear(new Date().getFullYear());
                      dtValorControl.setSeconds(0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setDate(new Date().getDate());
                      valorCondiction.setMonth(new Date().getMonth());
                      valorCondiction.setFullYear(new Date().getFullYear());
                      valorCondiction.setSeconds(0, 0);
                    }
                    break;
                  default:
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setSeconds(0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setSeconds(0, 0);
                    }
                    break;
                }
              } else {
                if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                    dtValorControl.setHours(0, 0, 0, 0);
                }
                if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                  valorCondiction.setHours(0, 0, 0, 0);
                }
              }
              // Operacion
              if (
                (dtValorControl instanceof Date && moment(dtValorControl).isValid()) &&
                (valorCondiction instanceof Date && moment(valorCondiction).isValid()) &&
                dtValorControl >= valorCondiction
              ) {
                comply = true;
              } else {
                comply = false;
              }
            }
            break;
          case 'Menor a':
            if (!date) {
              if (Number(valor) < Number(condiction.valor)) {
                comply = true;
              } else {
                comply = false;
              }
            } else {
              let dtValorControl: Date = null;
              let valorCondiction: Date = null;
              valorCondiction = new Date(condiction.valor);
              dtValorControl = new Date(valor);
              if (value && value.tipo && value.tipo === 'date-time-picker') {
                switch (value.clasificacion) {
                  case 'calendar':
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                        dtValorControl.setHours(0, 0, 0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setHours(0, 0, 0, 0);
                    }
                    break;
                  case 'timer':
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setDate(new Date().getDate());
                      dtValorControl.setMonth(new Date().getMonth());
                      dtValorControl.setFullYear(new Date().getFullYear());
                      dtValorControl.setSeconds(0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setDate(new Date().getDate());
                      valorCondiction.setMonth(new Date().getMonth());
                      valorCondiction.setFullYear(new Date().getFullYear());
                      valorCondiction.setSeconds(0, 0);
                    }
                    break;
                  default:
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setSeconds(0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setSeconds(0, 0);
                    }
                    break;
                }
              } else {
                if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                    dtValorControl.setHours(0, 0, 0, 0);
                }
                if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                  valorCondiction.setHours(0, 0, 0, 0);
                }
              }
              // Operacion
              if (
                (dtValorControl instanceof Date && moment(dtValorControl).isValid()) &&
                (valorCondiction instanceof Date && moment(valorCondiction).isValid()) &&
                dtValorControl < valorCondiction
              ) {
                comply = true;
              } else {
                comply = false;
              }
            }
            break;
          case 'Menor o igual a':
            if (!date) {
              if (Number(valor) <= Number(condiction.valor)) {
                comply = true;
              } else {
                comply = false;
              }
            } else {
              let dtValorControl: Date = null;
              let valorCondiction: Date = null;
              valorCondiction = new Date(condiction.valor);
              dtValorControl = new Date(valor);
              if (value && value.tipo === 'date-time-picker') {
                switch (value.clasificacion) {
                  case 'calendar':
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                        dtValorControl.setHours(0, 0, 0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setHours(0, 0, 0, 0);
                    }
                    break;
                  case 'timer':
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setDate(new Date().getDate());
                      dtValorControl.setMonth(new Date().getMonth());
                      dtValorControl.setFullYear(new Date().getFullYear());
                      dtValorControl.setSeconds(0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setDate(new Date().getDate());
                      valorCondiction.setMonth(new Date().getMonth());
                      valorCondiction.setFullYear(new Date().getFullYear());
                      valorCondiction.setSeconds(0, 0);
                    }
                    break;
                  default:
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setSeconds(0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setSeconds(0, 0);
                    }
                    break;
                }
              } else {
                if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                    dtValorControl.setHours(0, 0, 0, 0);
                }
                if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                  valorCondiction.setHours(0, 0, 0, 0);
                }
              }
              // Operacion
              if (
                (dtValorControl instanceof Date && moment(dtValorControl).isValid()) &&
                (valorCondiction instanceof Date && moment(valorCondiction).isValid()) &&
                dtValorControl <= valorCondiction
              ) {
                comply = true;
              } else {
                comply = false;
              }
            }
            break;
          case 'Se encuentra en los registros':
            if (!date) {
              const indexExist = valor.indexOf(condiction.valor);
              if (indexExist !== -1) {
                comply = true;
              } else {
                comply = false;
              }
            } else {
              const dates = this.calculateDateList(condiction, valor, value);
              let exist: Date;
              if (dates.valueControl && dates.valueControl.length) {
                exist = find(dates.valueControl, d => {
                  if (
                    (d instanceof Date && moment(d).isValid()) &&
                    (dates.valueCondiction instanceof Date && moment(dates.valueCondiction).isValid()) &&
                    // tslint:disable-next-line: max-line-length
                    d.toLocaleDateString() + ' - ' + d.toLocaleTimeString() === dates.valueCondiction.toLocaleDateString() + ' - ' + dates.valueCondiction.toLocaleTimeString()
                  ) {
                    return d;
                  }
                });
                if (exist) {
                  comply = true;
                } else {
                  comply = false;
                }
              } else {
                comply = false;
              }
            }
            break;
          case 'No se encuentra en los registros':
            if (!date) {
              const indexExist = valor.indexOf(condiction.valor);
              if (indexExist === -1) {
                comply = true;
              } else {
                comply = false;
              }
            } else {
              const dates = this.calculateDateList(condiction, valor, value);
              let exist: Date;
              if (dates.valueControl && dates.valueControl.length) {
                exist = find(dates.valueControl, d => {
                  if (
                    (d instanceof Date && moment(d).isValid()) &&
                    (dates.valueCondiction instanceof Date && moment(dates.valueCondiction).isValid()) &&
                    // tslint:disable-next-line: max-line-length
                    d.toLocaleDateString() + ' - ' + d.toLocaleTimeString() === dates.valueCondiction.toLocaleDateString() + ' - ' + dates.valueCondiction.toLocaleTimeString()
                  ) {
                    return d;
                  }
                });
                if (!exist) {
                  comply = true;
                } else {
                  comply = false;
                }
              } else {
                comply = false;
              }
            }
            break;
          default:
            if (!date) {
              if (String(valor).toLowerCase() === String(condiction.valor).toLowerCase()) {
                comply = true;
              } else {
                comply = false;
              }
            } else {
              let dtValorControl: Date = null;
              if (value && value.tipo && value.tipo === 'date-time-picker') {
                let valorCondiction: string = null;
                let valorControl: string = null;
                const dtValor: Date = new Date(condiction.valor);
                switch (value.clasificacion) {
                  case 'calendar':
                    valorCondiction = dtValor.toLocaleDateString();
                    dtValorControl = new Date(valor);
                    if (moment(dtValorControl).isValid()) {
                      valorControl = dtValorControl.toLocaleDateString();
                    }
                    break;
                  case 'timer':
                    dtValor.setSeconds(0, 0);
                    valorCondiction = dtValor.toLocaleTimeString();
                    dtValorControl = new Date(valor);
                    if (moment(dtValorControl).isValid()) {
                      dtValorControl.setSeconds(0, 0);
                      valorControl = dtValorControl.toLocaleTimeString();
                    }
                    break;
                  default:
                    dtValor.setSeconds(0, 0);
                    valorCondiction = dtValor.toLocaleDateString();
                    valorCondiction += ' ' + dtValor.toLocaleTimeString();
                    dtValorControl = new Date(valor);
                    if (moment(dtValorControl).isValid()) {
                      dtValorControl.setSeconds(0, 0);
                      valorControl = dtValorControl.toLocaleDateString();
                      valorControl += ' ' + dtValorControl.toLocaleTimeString();
                    }
                    break;
                }
                if (valorControl === valorCondiction) {
                  comply = true;
                } else {
                  comply = false;
                }
              } else {
                dtValorControl = new Date(valor);
                // tslint:disable-next-line:max-line-length
                if (moment(dtValorControl).isValid() && dtValorControl.toLocaleDateString() === new Date(condiction.valor).toLocaleDateString()) {
                  comply = true;
                } else {
                  comply = false;
                }
              }
            }
            break;
        }
        switch (condiction.accion) {
          case 'Mostrar':
            if (!firstView) {
              if (!operactorNext || operactorNext === 'O') {
                if (valView || comply) {
                  valView = true;
                } else {
                  valView = false;
                }
              } else {
                if (valView && comply) {
                  valView = true;
                } else {
                  valView = false;
                }
              }
            } else {
              firstView = false;
              firstHide = true;
              valView = comply;
            }
            valHide = !valView;
            operactorNext = condiction.operadorCondicion;
            break;
          case 'Ocultar':
            if (!firstHide) {
              if (!operactorNext || operactorNext === 'O') {
                if (valHide || comply) {
                  valHide = true;
                } else {
                  valHide = false;
                }
              } else {
                if (valHide && comply) {
                  valHide = true;
                } else {
                  valHide = false;
                }
              }
            } else {
              firstHide = false;
              firstView = true;
              valHide = comply;
            }
            valView = !valHide;
            operactorNext = condiction.operadorCondicion;
            break;
        }
      });
      if (valView || !valHide) {
        valid = true;
      } else {
        valid = false;
      }
    }
    if (!valid) {
      const doc = find(this.source, {clasificacion_id: document.clasificacion_id, idtarea: document.idtarea});
      if (doc) {
        if (doc.funciones && doc.funciones.length) {
          const indexfunction = findIndex(doc.funciones, {funcion: funcion});
          if (indexfunction !== -1) {
            doc.funciones.splice(indexfunction, 1);
          }
        }
      }
    }
  }

  /**
   * Calcula las fechas de la condicion y el valor por el cual se condicionara
   * estas fechas toman el formato indicado por el tipo
   *
   * @private
   * @param {CondicionDocumento} condiction
   * @param {any[]} valor
   * @param {Datos} [value]
   * @returns {DatesCondiction}
   * @memberof DocsComponent
   */
  private calculateDateList(condiction: CondicionDocumento, valor: any[], value?: Datos): DatesCondiction {
    const dtValorControl: Date[] = [];
    let valorCondiction: Date = null;
    const moment = require('moment');
    valorCondiction = new Date(condiction.valor);
    if (valor && valor.length) {
      valor.forEach(v => {
        dtValorControl.push(new Date(v));
      });
    }
    if (value && value.tipo === 'date-time-picker') {
      switch (value.clasificacion) {
        case 'calendar':
          if (dtValorControl && dtValorControl.length) {
            dtValorControl.forEach(dt => {
              if (dt && dt instanceof Date && moment(dt).isValid()) {
                  dt.setHours(0, 0, 0, 0);
              }
            });
          }
          if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
            valorCondiction.setHours(0, 0, 0, 0);
          }
          break;
        case 'timer':
          if (dtValorControl && dtValorControl.length) {
            dtValorControl.forEach(dt => {
              if (dt && dt instanceof Date && moment(dt).isValid()) {
                dt.setDate(new Date().getDate());
                dt.setMonth(new Date().getMonth());
                dt.setFullYear(new Date().getFullYear());
                dt.setSeconds(0, 0);
              }
            });
          }
          if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
            valorCondiction.setDate(new Date().getDate());
            valorCondiction.setMonth(new Date().getMonth());
            valorCondiction.setFullYear(new Date().getFullYear());
            valorCondiction.setSeconds(0, 0);
          }
          break;
        default:
          if (dtValorControl && dtValorControl.length) {
            dtValorControl.forEach(dt => {
              if (dt && dt instanceof Date && moment(dt).isValid()) {
                dt.setSeconds(0, 0);
              }
            });
          }
          if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
            valorCondiction.setSeconds(0, 0);
          }
          break;
      }
    } else {
      if (dtValorControl && dtValorControl.length) {
        dtValorControl.forEach(dt => {
          if (dt && dt instanceof Date && moment(dt).isValid()) {
              dt.setHours(0, 0, 0, 0);
          }
        });
      }
      if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
        valorCondiction.setHours(0, 0, 0, 0);
      }
    }
    return {valueCondiction: valorCondiction, valueControl: dtValorControl};
  }

  /**
   * Define la accion a realizar dependiendo de la opcion seleccionada en la tabla
   *
   * @private
   * @param {*} data
   * @returns {*}
   * @memberof DocsComponent
   */
  private accionTable(data: any): any {
    if (data.accion === 'download') {
      if (data.data['documento_cita']) {
        const a = document.createElement('a');
        a.href = Const.ROUTES_SYSTEM_INTEGRATIONS.cita.dowloadDocument + data.data['documento_cita'];
        a.click();
        a.remove();
        const indexDownload = findIndex(this.documentsDownload, el => el === data.data['id_documento']);
        if (indexDownload === -1) {
          this.documentsDownload.push(data.data['id_documento']);
          this.docsDownload.emit(this.documentsDownload);
        }
      } else if (data.data['id_documento']) {
        this.download(data.data['id_documento']);
      }
    } else if (data.accion === 'review') {
      this.reviewDocument(data.data);
    } else if (data.accion === 'generate') {
      this.generateDocument(data.data);
    } else if (data.accion === 'error') {
      this.toastr.error(data.message, 'Error de accion');
    }
  }

  /**
   * Genera el documento seleccionado
   *
   * @private
   * @param {Documento} data
   * @memberof DocsComponent
   */
  private async generateDocument(data: Documento) {
    this.source[0]['select'] = true;
    const dataDocument = {
      tarea: data.idtarea,
      documento: data.clasificacion_id
    };
    await this.dds.generateDocument(dataDocument).subscribe(file => {
      const a = document.createElement('a');
      a.target = '_blank';
      a.href = file.url.path;
      a.download = file.url.name;
      a.click();
      a.remove();
      this.source[0]['select'] = false;
      this.registerGeneratedDocument(data, false);
    },err=>{
      this.registerGeneratedDocument(data, true);
      // this.source[0]['select'] = false;
    });
    this.sourceData.refresh();
  }

  /**
   * Registra el documento como generado para las restriciones de validar las funciones de los documentos
   *
   * @private
   * @param {Documento} doc
   * @memberof DocsComponent
   */
  private registerGeneratedDocument(doc: Documento, error?: boolean) {
    if(!error){
      const exist = findIndex(
        this.documentsGenerated,
        {
          clasificacion_id: doc.clasificacion_id,
          idtarea: doc.idtarea
        }
      );
      if (exist === -1) {
        const documentFuntion = find(doc.funciones, {funcion: Const.DOCUMENTS_FUNCTIONS.generate});
        this.documentsGenerated.push({
          clasificacion_id: doc.clasificacion_id,
          idtarea: doc.idtarea
        });
        if (documentFuntion.obligatorio) {
          this.toastr.success('Ya puedes subir este documento', 'Acción activada', {
            positionClass: 'toast-top-center'
          });
        }
        this.docsGenerate.emit(this.documentsGenerated);
      }
      this.docsGenerate.emit(this.documentsGenerated);
    }
    this.source[0]['select'] = false;
    this.sourceData.refresh();
  }

  /**
   * Valida si el documento tiene la funcion de generar este generado.
   * Si el documento tiene la funcion de generar pero no es obligatoria
   * en caso de no haberse generado la respuesta es true.
   * Si el documento no tiene la funcion la respuesta es true.
   *
   * @private
   * @param {Documento} doc
   * @returns {boolean}
   * @memberof DocsComponent
   */
  private validateGeneratedDocument(doc: Documento): boolean {
    const exist = findIndex(
      this.documentsGenerated,
      {
        clasificacion_id: doc.clasificacion_id,
        idtarea: doc.idtarea
      }
    );
    if (exist !== -1) {
      return true;
    } else {
      const documentFuntion = find(doc.funciones, {funcion: Const.DOCUMENTS_FUNCTIONS.generate});
      if (documentFuntion) {
        if (doc.documentos_detalle.length) {
          return true;
        } else {
          return !documentFuntion.obligatorio;
        }
      } else {
        return true;
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/forms/shared/docs/docs.component.ts